var _path, _g, _path2, _g2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageOver18 = function SvgImageOver18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Image_Over18_svg__a)",
    stroke: "url(#Image_Over18_svg__b)",
    d: "M49.998 5.857c24.38 0 44.143 19.764 44.144 44.143S74.378 94.144 49.998 94.144 5.855 74.379 5.855 50c0-24.38 19.764-44.142 44.143-44.143Zm27.771 23.636L29.491 77.772l-.417.415.479.344A34.94 34.94 0 0 0 49.998 85.1c19.384 0 35.099-15.715 35.099-35.099a34.94 34.94 0 0 0-6.568-20.445l-.343-.479zm-27.771-14.59C30.614 14.902 14.901 30.615 14.9 50c0 7.669 2.46 14.765 6.634 20.54l.344.475L71.013 21.88l-.476-.344a34.94 34.94 0 0 0-20.539-6.634Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00C499",
    fillOpacity: 0.5,
    filter: "url(#Image_Over18_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.454 72.322q-4.193 0-7.448-1.727-3.254-1.726-5.102-4.791-1.847-3.066-1.847-7.024 0-3.542 1.613-6.578 1.612-3.035 4.72-4.85l-.146 2.291q-2.434-1.875-3.783-4.315-1.32-2.47-1.319-5.536 0-3.69 1.7-6.399 1.73-2.709 4.721-4.196 2.991-1.518 6.89-1.518 3.9 0 6.891 1.518 3.02 1.487 4.721 4.196 1.73 2.708 1.73 6.399 0 3.066-1.29 5.506-1.26 2.44-3.841 4.404l-.03-2.32q3.05 1.755 4.663 4.82 1.641 3.036 1.642 6.578 0 3.958-1.877 7.024-1.847 3.065-5.131 4.791-3.255 1.727-7.477 1.727m0-6.756q3.108 0 5.043-1.727 1.965-1.725 1.965-5.06 0-3.332-1.936-5.059-1.934-1.756-5.072-1.756-3.108 0-5.014 1.756-1.905 1.727-1.906 5.06t1.906 5.06q1.905 1.725 5.014 1.726m0-20.417q2.61 0 4.222-1.31 1.642-1.339 1.642-4.047 0-2.709-1.642-4.018-1.612-1.34-4.222-1.34-2.58 0-4.222 1.34-1.614 1.31-1.613 4.018 0 2.708 1.613 4.047 1.641 1.31 4.222 1.31M45.478 71.351a1.925 1.925 0 0 1-1.926-1.925V36.448l-5.135 3.118c-1.283.779-2.925-.145-2.925-1.646v-3.373c0-.678.357-1.307.94-1.654l7.12-4.244h5.418c1.064 0 1.926.862 1.926 1.926v38.85a1.926 1.926 0 0 1-1.926 1.926z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Image_Over18_svg__d)",
    stroke: "url(#Image_Over18_svg__e)",
    strokeWidth: 0.223,
    d: "M71.454 27.79q3.877 0 6.84 1.506 2.995 1.477 4.677 4.156v.001q1.712 2.677 1.713 6.339 0 3.04-1.278 5.453v.001q-.833 1.612-2.254 3.019a13 13 0 0 0-1.462-.98l-.17-.098.002.196.03 2.321.003.222.176-.135q.778-.592 1.436-1.228a11.6 11.6 0 0 1 3.031 3.692q1.63 3.011 1.63 6.525-.001 3.929-1.861 6.965v.001q-1.716 2.85-4.687 4.531l-.401.22q-3.227 1.712-7.425 1.713-4.17 0-7.395-1.713-3.228-1.712-5.059-4.75-1.83-3.037-1.831-6.967 0-3.514 1.6-6.525a11.8 11.8 0 0 1 3.053-3.692q.629.61 1.354 1.168l.166.128.014-.209.146-2.292.014-.209-.182.106q-.796.465-1.497 1.01a13.2 13.2 0 0 1-2.278-2.992q-1.305-2.442-1.305-5.481.001-3.663 1.684-6.34h-.002q1.713-2.681 4.677-4.155l.001-.001q2.963-1.505 6.84-1.506Zm-22.483.97c1.001.001 1.813.813 1.813 1.814v38.852a1.814 1.814 0 0 1-1.813 1.813h-3.493a1.813 1.813 0 0 1-1.814-1.813V36.25l-.17.102-5.136 3.119c-1.208.733-2.754-.137-2.754-1.551v-3.373c0-.64.336-1.23.885-1.558l7.094-4.228zm22.483 23.092c-2.094 0-3.794.593-5.089 1.786-1.3 1.178-1.942 2.898-1.942 5.142s.642 3.964 1.942 5.142c1.295 1.173 2.995 1.755 5.09 1.755 1.962 0 3.587-.511 4.865-1.541l.251-.213c1.34-1.178 2.002-2.898 2.002-5.143s-.652-3.966-1.972-5.143c-1.315-1.193-3.034-1.784-5.147-1.785Zm8.294-4.274q.656.39 1.243.844-.564.543-1.219 1.054zm-16.603 1.846a16 16 0 0 1-1.147-1.001q.597-.463 1.268-.866zm8.31-15.1c-1.632 0-2.995.396-4.081 1.198l-.213.166c-1.109.9-1.654 2.276-1.654 4.104s.546 3.213 1.653 4.133l.002.002c1.119.892 2.553 1.334 4.292 1.334 1.759 0 3.193-.442 4.292-1.335h.001c1.127-.92 1.683-2.305 1.683-4.134s-.556-3.205-1.685-4.105c-1.1-.912-2.533-1.364-4.29-1.364Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Image_Over18_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C499",
    fillOpacity: 0.5,
    d: "M22.437 62.277a1.73 1.73 0 0 1-1.73-1.729v-8.03h-8.04a1.73 1.73 0 0 1-1.73-1.73v-1.602c0-.955.775-1.73 1.73-1.73h8.04v-8.003c0-.955.775-1.73 1.73-1.73h1.608c.955 0 1.73.775 1.73 1.73v8.003h7.987c.955 0 1.73.775 1.73 1.73v1.602a1.73 1.73 0 0 1-1.73 1.73h-7.988v8.03a1.73 1.73 0 0 1-1.729 1.73z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Image_Over18_svg__g)",
    stroke: "url(#Image_Over18_svg__h)",
    strokeWidth: 0.223,
    d: "M22.437 37.835h1.608c.893 0 1.618.725 1.618 1.618v8.115h8.099c.893 0 1.618.724 1.618 1.617v1.603c0 .893-.725 1.618-1.618 1.618h-8.099v8.142c0 .893-.725 1.618-1.618 1.618h-1.609a1.62 1.62 0 0 1-1.617-1.618v-8.142h-8.152a1.62 1.62 0 0 1-1.618-1.618v-1.602c0-.894.725-1.618 1.618-1.618h8.152v-8.115c0-.893.724-1.618 1.617-1.618Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Image_Over18_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-45 116.922 40.857)scale(126.269 252.768)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BA7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171029",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Image_Over18_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 44.6429 -88.9728 0 56.864 27.679)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Image_Over18_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 24.2077 -49.1079 0 23.214 37.724)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Image_Over18_svg__b",
    x1: 94.999,
    x2: 49.998,
    y1: 5,
    y2: 94.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Image_Over18_svg__e",
    x1: 60.715,
    x2: 60.715,
    y1: 27.679,
    y2: 72.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Image_Over18_svg__h",
    x1: 23.214,
    x2: 23.214,
    y1: 37.724,
    y2: 62.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Image_Over18_svg__c",
    width: 55.803,
    height: 50,
    x: 32.814,
    y: 25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_11349_22878",
    stdDeviation: 1.339
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Image_Over18_svg__f",
    width: 29.912,
    height: 29.911,
    x: 8.259,
    y: 35.045,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_11349_22878",
    stdDeviation: 1.339
  })))));
};
export default SvgImageOver18;